const CommunityGuidelines = () => {
  return (
    <div className="Policies">
      <div className="container max-w-6xl mx-auto px-4">
        <h1
          style={{
            textAlign: 'center',
          }}
        >
          COMMUNITY GUIDELINES
        </h1>

        <ol>
          <li style={{ fontSize: '24px' }}>
            <h4>Introduction</h4>
          </li>
        </ol>
        <p>
          Welcome to our tutoring platform, where our goal is to provide a safe, educational, and
          inclusive space for all users to learn about cryptocurrency. Our platform is dedicated to
          fostering a community of individuals who are passionate about cryptocurrency and eager to
          learn and share their knowledge with others. The following Community Guidelines are
          designed to ensure that our users can engage with each other in a respectful and
          productive manner and that everyone feels safe and valued. These guidelines apply to all
          users and all content on the platform, and we expect all users to abide by them.
        </p>

        <ol start={2}>
          <li style={{ fontSize: '24px' }}>
            <h4>Respectful Behavior</h4>
          </li>
        </ol>
        <p>
          Respect is a core value of our platform, and we expect all users to treat others with
          kindness, respect, and understanding. This means avoiding the use of language that is
          harmful, abusive, threatening, defamatory, or discriminatory, including hate speech and
          personal attacks. It also means avoiding behavior that could be perceived as disruptive,
          harassing, or intimidating to others. If you disagree with someone, it is important to do
          so in a respectful and constructive manner, focusing on the issues at hand and avoiding
          personal attacks.
        </p>

        <ol start={3}>
          <li style={{ fontSize: '24px' }}>
            <h4>Illegal Activities</h4>
          </li>
        </ol>
        <p>
          Our platform strictly prohibits illegal activities and behavior harmful to others. This
          includes, but is not limited to, the promotion of illegal acts, hate speech, and spam.
          Users must not engage in or promote any activity that is unlawful or unethical, such as
          the sale of illegal or controlled substances, stolen goods, or the distribution of
          malware. Violations of this policy will result in immediate action by our moderators,
          including content removal and account termination.
        </p>

        <ol start={4}>
          <li style={{ fontSize: '24px' }}>
            <h4>Intellectual Property</h4>
          </li>
        </ol>
        <p>
          Respect for the intellectual property of others is a key principle of our platform, and we
          expect all users to comply with applicable intellectual property laws and regulations.
          This includes, but is not limited to, trademarks, copyrights, patents, and trade secrets.
          Do not use or post any material that you do not have the right to use, or that infringes
          on the intellectual property rights of others. This includes using materials from other
          websites, books, or other sources without proper attribution or permission. If you believe
          that your intellectual property rights have been infringed, please contact our platform
          moderators.
        </p>

        <ol start={5}>
          <li style={{ fontSize: '24px' }}>
            <h4>Content</h4>
          </li>
        </ol>
        <p>
          Our platform is for educational purposes, and any content posted should be relevant and
          appropriate to the subject matter of cryptocurrency. This includes, but is not limited to,
          articles, videos, images, and discussions. Avoid posting content that is off-topic,
          irrelevant, or inappropriate, such as adult content, violence, or hate speech.
          Additionally, we do not allow the posting of content that is designed to mislead or
          deceive others, such as fake news, false information, or deliberately misleading
          information. Our moderators will review reported content and take appropriate action,
          including removing the content and terminating user accounts if necessary.
        </p>

        <ol start={6}>
          <li style={{ fontSize: '24px' }}>
            <h4>Marketing and Promotion</h4>
          </li>
        </ol>
        <p>
          Our platform is not intended for commercial purposes, and we do not allow the use of the
          platform to engage in commercial activities, including the promotion of products or
          services, except where specifically allowed. Additionally, do not engage in spamming,
          phishing, or any other malicious activities. This includes, but is not limited to, the
          posting of unsolicited commercial messages, the use of false or misleading information, or
          the use of automated systems to post or send messages.
        </p>

        <ol start={7}>
          <li style={{ fontSize: '24px' }}>
            <h4>Reporting Violations</h4>
          </li>
        </ol>
        <p>
          If you witness a violation of these Community Guidelines, please report it to our platform
          moderators by using the appropriate reporting tools provided. Our moderators will review
          the report and take appropriate action, which may include removing the content, blocking
          the user, or terminating the user account. If you have any concerns or questions about
          these guidelines, please contact us at{' '}
          <a href="mailto:support@apolop2p.com">support@apolop2p.com</a>.
        </p>

        <ol start={8}>
          <li style={{ fontSize: '24px' }}>
            <h4>Enforcement</h4>
          </li>
        </ol>
        <p>
          Our platform takes violations of these Community Guidelines seriously, and we reserve the
          right to take appropriate action to enforce them. This may include removing content,
          blocking users, or terminating accounts. Our moderators will investigate reported
          violations and take appropriate action based on the severity of the violation and the
          user's past behavior on the platform. We believe in being transparent and fair in our
          enforcement actions. We encourage users to report any violations they witness so that we
          can take appropriate action.
        </p>

        <ol start={9}>
          <li style={{ fontSize: '24px' }}>
            <h4>Changes to Guidelines</h4>
          </li>
        </ol>
        <p>
          These Community Guidelines may be revised from time to time to reflect changes in the
          platform, in the crypto industry, or to address emerging issues. We will make every effort
          to communicate any significant changes to our users. However, it is your responsibility to
          regularly review these guidelines to ensure that you are aware of any changes. By
          continuing to use our platform, you agree to be bound by the most current version of these
          Community Guidelines.
        </p>

        <ol start={10}>
          <li style={{ fontSize: '24px' }}>
            <h4>Conclusion</h4>
          </li>
        </ol>
        <p>
          We are committed to creating a positive and productive community on our tutoring platform,
          and these Community Guidelines are designed to help achieve that goal. By using our
          platform, you agree to abide by these guidelines and to help create a safe, educational,
          and inclusive space for all users. We appreciate your cooperation and look forward to your
          participation and contributions. Thank you for your support.
        </p>
      </div>
    </div>
  )
}

export default CommunityGuidelines
